const tiles = [
  {cls: 't1', label: 'Atelier', title: ['Objects', 'for living.']},
  {cls: 't2', label: 'COMMON GROUND', title: ['Good coffee.', 'Better company.']},
  {cls: 't3', label: 'FORM', title: ['Spaces that', 'feel like you.']},
  {cls: 't4', label: 'FIELD NOTES', title: ['Stories from', 'the outside.']},
  {cls: 't5', label: 'STUDIO N°7', title: ['Ideas made', 'visible.']},
  {cls: 't6', label: 'NOURISH', title: ['Wellness,', 'made simple.']},
];

export function TemplatesBandSection() {
  return (
    <section className="templates-band" id="templates">
      <div className="shell">
        <div className="template-copy fade-up">
          <span className="kicker">120+ TEMPLATES</span>
          <h2>
            Start inspired.
            <br />
            Make it <em>yours.</em>
          </h2>
          <p>Every template is responsive, thoughtfully designed, and ready to adapt to your idea.</p>
          <a className="btn-dark-landing" href="/register">
            Explore all templates &#8599;
          </a>
        </div>
        <div className="template-wall" aria-label="Sample templates">
          {tiles.map(tile => (
            <div key={tile.cls} className={`tpl ${tile.cls}`}>
              <small>{tile.label}</small>
              <b>
                {tile.title[0]}
                <br />
                {tile.title[1]}
              </b>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
